import env from "../config/env";
import { endpoints } from "./endpoints";
import { httpClient } from "./httpClient";

export const listGitlabUsers = async () => {
  const result = await httpClient.get(endpoints.listUsers());

  if (!result.ok) {
    console.error("Error fetching GitLab users:", result.message);
    return [];
  }

  if (result.data?.records && Array.isArray(result.data.records)) {
    return result.data.records;
  }

  return [];
};

export const fetchIssuesForUser = async (username) => {
  const result = await httpClient.postForm(endpoints.trackIssues(username), {
    key: env.gitdashApiKey,
  });

  if (!result.ok) {
    return { error: result.message };
  }

  if (result.data?.type === "ERROR") {
    return { error: result.data.message || "An error occurred" };
  }

  return result.data;
};
